"use client";
// components/MerchantWidget.js
import Script from "next/script";
// import {
//   useEffect
// } from "react";
import {
  useIsMobile
} from "@/hooks/use-is-mobile";

export const MerchantWidget = () => {
  // useEffect(() => {
  //   // 检查脚本是否存在
  //   const script = document.getElementById("merchantWidgetScript");

  //   console.log("Script element exists:", !!script);
    
  //   // 检查 merchantwidget 对象是否存在
  //   console.log("Merchantwidget object exists:", !!window.merchantwidget);

  //   const handleScriptLoad = () => {
  //     console.log("Script load handler called");

  //     if (window.merchantwidget) {
  //       console.log("Attempting to start merchantwidget");

  //       try {
  //         window.merchantwidget.start({
  //           position: "RIGHT_BOTTOM"
  //         });
  //         console.log("Merchantwidget started successfully");
  //       } catch (error) {
  //         console.error("Error starting merchantwidget:", error);
  //       }
  //     } else {
  //       console.error("Merchantwidget object not found after script load");
  //     }
  //   };

  //   if (script && window.merchantwidget) {
  //     handleScriptLoad();
  //   }
  // }, []);

  const {
    isMobile
  } = useIsMobile();

  return (
    <Script
      id='merchantWidgetScript'
      src='https://www.gstatic.com/shopping/merchant/merchantwidget.js'
      strategy='lazyOnload'
      onLoad={() => {
        console.log("Script onLoad event fired");

        if (window?.merchantwidget) {
          console.log("Attempting to start merchantwidget from onLoad");

          try {
            // https://support.google.com/merchants/answer/14428754#where_to_add_top_q_score
            window?.merchantwidget.start({
              position: "LEFT_BOTTOM",
              sideMargin: isMobile ? 16 : 21,
              bottomMargin: isMobile ? 33 : 33, // 中间位置
              mobileSideMargin: isMobile ? 16 : 11,
              mobileBottomMargin: isMobile ? 100 : 100, // 中间位置
              zIndex: 48
            });
            console.log("Merchantwidget started successfully from onLoad");
          } catch (error) {
            console.error("Error starting merchantwidget from onLoad:", error);
          }
        } else {
          console.error("Merchantwidget object not found in onLoad handler");
        }
      }}
    />
  );
};

